import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO';
import { portalApi } from '../../lib/portalApi';
import { ArrowRight } from 'lucide-react';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    setLoading(true);
    try {
      const res = await portalApi.forgotPassword(email);
      setMsg(res.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title="Forgot Password" description="Reset your InnovHer portal password." />
      <section className="min-h-screen bg-[#08080a] flex items-center justify-center p-6 pt-24">
        <div className="w-full max-w-md bg-white/[0.02] border border-white/10 p-8 rounded-3xl">
          <h1 className="text-2xl font-semibold text-white mb-2">Forgot password</h1>
          <p className="text-white/60 text-sm mb-6">Enter your email and we&apos;ll send a reset link.</p>
          <form onSubmit={submit} className="space-y-4">
            {error && <div className="p-3 rounded-lg bg-red-500/10 text-red-400 text-sm">{error}</div>}
            {msg && <div className="p-3 rounded-lg bg-green-500/10 text-green-400 text-sm">{msg}</div>}
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white"
              placeholder="you@company.com"
            />
            <button type="submit" disabled={loading} className="w-full bg-[#d42b92] hover:bg-[#ff8ec5] text-white py-3 rounded-xl font-medium disabled:opacity-50">
              {loading ? 'Sending...' : 'Send reset link'} <ArrowRight className="w-4 h-4 inline" />
            </button>
          </form>
          <Link to="/login" className="block text-center text-sm text-[#ff8ec5] mt-6 hover:underline">Back to sign in</Link>
        </div>
      </section>
    </>
  );
}
